import { SimpleForm, useRecordContext, useRedirect, useUpdate } from "react-admin";
import { FieldValues } from "react-hook-form";
import { OptimizerResourcesEnum } from "shared/enums/resourceMappings";
import { TransformGroupCertificationData } from "./types";
import { transformGroupCertificationData } from "./utils";
import { Skeleton } from "@mui/material";
import GroupCertificationEditInputs from "./GroupCertificationEditInputs";

const GroupCertificationEditFormSite = () => {
  const record = useRecordContext();
  const [update, { isPending }] = useUpdate();
  const redirect = useRedirect();

  const handleSubmit = (values: FieldValues) => {
    update(
      OptimizerResourcesEnum.OptiGroupsCertifications,
      {
        id: record && record.id,
        data: transformGroupCertificationData(values as TransformGroupCertificationData),
        meta: {
          method: "PATCH",
        },
      },
      {
        onSuccess: () => {
          redirect("list", OptimizerResourcesEnum.OptiGroupsCertifications);
        },
        onError: (error: any) => {
          console.log("error:", error);
        },
      },
    );
    redirect("list", OptimizerResourcesEnum.OptiGroupsCertifications);
  };

  if (isPending) {
    return <Skeleton variant="text" width="100%" height={300} />;
  }

  return (
    <SimpleForm onSubmit={handleSubmit}>
      <GroupCertificationEditInputs />
    </SimpleForm>
  );
};

export default GroupCertificationEditFormSite;
